import React, { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { Locale } from '../types';

interface LocaleContextType {
  selectedLocale: Locale;
  setSelectedLocale: (locale: Locale) => void;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

interface LocaleProviderProps {
  children: ReactNode;
}

export const LocaleProvider: React.FC<LocaleProviderProps> = ({ children }) => {
  const [selectedLocale, setSelectedLocale] = useState<Locale>(() => {
    const saved = localStorage.getItem('selectedLocale');
    return (saved as Locale) || Locale.ru;
  });

  useEffect(() => {
    localStorage.setItem('selectedLocale', selectedLocale);
  }, [selectedLocale]);

  return (
    <LocaleContext.Provider value={{ selectedLocale, setSelectedLocale }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = (): LocaleContextType => {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within a LocaleProvider');
  }
  return context;
};
